<template>
  <div>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="secondary" rounded elevation="0" height="54" width="330" v-bind="attrs" v-on="on">
          <span class="text-base font-black">{{ $t('consult_the_itinerary') }}</span>
        </v-btn>
      </template>
      <v-card>
        <div class="itinerary-detail">
          <v-btn @click="dialog = false" depressed text class="btn-back">
            <span class="text-base font-bold"> < {{ $t('go_back') }}</span>
          </v-btn>
          <slot></slot>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
export default {
  data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
    }
  },
}
</script>

<style lang="scss">
@import "../../../sass/variables";

.itinerary-detail {
  padding: 30px 100px;
  background-color: $white;

  @media screen and (max-width: $breakpoint-landing-phone) {
    padding: 30px 1rem;

  }
  .btn-back {
    position: absolute;
    top: 20px;
    left: 80px;
    @media screen and (max-width: $breakpoint-landing-phone) {
    left: 0;

  }
  }
}
</style>
